import { LinearProgress, Snackbar } from "@mui/material";
import Alert from "@mui/material/Alert";
import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import {
  importsBulkUploadStore,
  closeBulkImportsSuccessSnackbar,
  closeBulkImportsCancelledSnackbar,
  closeBulkImportsErrorSnackbar,
} from "stores/importsUploadStore";

interface IProps {
  type: string;
}

const bulkContexts: {
  [key: string]: {
    store: any;
    successMessageId: string;
    closeSuccessSnackbar: () => void;
    closeCancelledSnackbar: () => void;
    closeErrorSnackbar: () => void;
  };
} = {
  imports: {
    store: importsBulkUploadStore,
    successMessageId: "importsUploadSuccess",
    closeSuccessSnackbar: closeBulkImportsSuccessSnackbar,
    closeCancelledSnackbar: closeBulkImportsCancelledSnackbar,
    closeErrorSnackbar: closeBulkImportsErrorSnackbar,
  },
};

const BulkUploadProgress: FunctionComponent<IProps> = ({ type }) => {
  const { formatMessage: t } = useIntl();
  const bulkContext = bulkContexts[type];

  const {
    progress,
    showSuccessSnackbar,
    showCancelledSnackbar,
    showErrorSnackbar,
    isLoading,
    errorSnackbarMessage,
    cancelledSnackbarMessageId = "bulkUploadCancelled",
  } = bulkContext.store.useState((s: any) => ({
    progress: s.bulkUploadProgressStatus,
    showSuccessSnackbar: s.showSuccessSnackBar,
    showCancelledSnackbar: s.showCancelledSnackbar,
    showErrorSnackbar: s.showErrorSnackbar,
    isLoading: s.showBulkUploadProgress,
    errorSnackbarMessage: s.errorSnackbarMessage,
    cancelledSnackbarMessageId: s.cancelledSnackbarMessageId,
  }));

  return (
    <div>
      {isLoading && (
        <LinearProgress
          color="secondary"
          variant="determinate"
          value={progress}
        />
      )}

      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={showSuccessSnackbar}
        autoHideDuration={5000}
        onClose={bulkContext.closeSuccessSnackbar}
      >
        <Alert
          onClose={bulkContext.closeSuccessSnackbar}
          severity="success"
          elevation={6}
          variant="filled"
        >
          {t({ id: bulkContext.successMessageId })}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={showCancelledSnackbar}
        autoHideDuration={5000}
        onClose={bulkContext.closeCancelledSnackbar}
      >
        <Alert
          onClose={bulkContext.closeCancelledSnackbar}
          severity="warning"
          elevation={6}
          variant="filled"
        >
          {t({ id: cancelledSnackbarMessageId })}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={showErrorSnackbar}
        onClose={bulkContext.closeErrorSnackbar}
      >
        <Alert
          onClose={bulkContext.closeErrorSnackbar}
          severity="error"
          elevation={6}
          variant="filled"
        >
          {t(
            { id: "bulkUploadError" },
            {
              value: errorSnackbarMessage.value,
              field: errorSnackbarMessage.field,
            }
          )}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default BulkUploadProgress;
